import { LOCALES } from '../locales';

export default {
  [LOCALES.FRENCH]: {
    "L'Oreal Paris Revitalift Crystal Micro-Essence Face Serum 22 ml":
      "L'Oreal Paris Revitalift Crystal Micro-Essence Sérum Visage 22 ml",
    'DressBerry Women Peach-Coloured Solid Flats':
      'DressBerry Femmes Appartements unis couleur pêche',
    'ZAPATOZ Women White Sneakers': 'ZAPATOZ Femmes Baskets Blanches',
    'Crocs Unisex Navy Blue Solid Bayaband Clogs':
      'Sabots Crocs Unisexe Bleu Marine Solid Bayaband',
    'SASSAFRAS Black & Pink Printed Wrap Dress':
      'Robe portefeuille imprimée noire et rose SASSAFRAS',
    'Tokyo Talkies Navy Polka Dot Belted Shirt Dress':
      'Tokyo Talkies - Robe chemise ceinturée à pois bleu marine',
    'SASSAFRAS Women Maroon Solid Tiered Maxi Dress':
      'SASSAFRAS Robe Longue Marron Solide',
    'Daniel Klein Premium Women Silver-Toned Dial Watch DK11138-2s':
      'Daniel Klein Premium Montre Femme Cadran Argenté DK11138-2s',
    'MANGO Burgundy Solid Tote Bag': 'Sac fourre-tout uni bordeaux MANGO',
    Filter: 'Filtre',
    Filters: 'Filtres',
    Category: 'Catégorie',
    Categories: 'Catégories',
    'Search Products': 'Recherche de produits',
    'E-mail': 'E-mail',
    'Sign-in': `S'identifier`,
    Password: 'Mot de passe',
    'Create your account': 'Créez votre compte',
    'or sign-in with:': 'ou connectez-vous avec:',
    Google: 'Google',
    Facebook: 'Facebook',
    Phone: 'Téléphone',
    'Hello, Guest': 'Bonjour, Invité',
    'SHOP NOW': 'ACHETEZ MAINTENANT',
    'PARTY WEAR': 'USURE DE FÊTE',
    'CASUAL WEAR': 'VÊTEMENT DE TOUS LES JOURS',
    ACCESSORIES: 'ACCESSOIRES',
    FOOTWEAR: 'CHAUSSURE',
    'Redefine your fashion with these stunning casual wear':
      'Redéfinissez votre mode avec ces superbes tenues décontractées',
    'Sophesticated accessories to make your look and life a paradise.':
      'Des accessoires sophistiqués pour faire de votre look et de votre vie un paradis.',
    'Footwear that makes you comfortable and look good.':
      'Des chaussures confortables et esthétiques.',
    'Dress up for parties with the spirit of passion': `Habillez-vous pour les fêtes avec l'esprit de passion`,
    German: 'Allemand',
    French: 'Français',
    English: 'Anglais',
    'Learn More': 'Apprendre encore plus',
    'Classic Collection 2021': 'Collection Classique 2021',
    'COLLECTION 2021': 'COLLECTION 2021',
    'Fresh Collection 2021': 'Collection fraîche 2021',
    'Fashion Collection 2021': 'Collection de mode 2021',
    Login: 'Connexion',
    Account: 'Compte',
    Orders: 'Ordres',
    'Featured Products': 'Produits populaires',
    'Recommended for you': 'Recommandé pour vous',
    'Tinny Three Quarter Sleeve Dress': 'Robe moulante à manches trois-quarts',
    'Vila Striped T-Shirt Dress': 'Robe t-shirt à rayures Vila',
    'Sleeveless Deana Maxi Dress': 'Robe maxi Deana sans manches',
    About: 'À propos de',
    Services: 'Prestations de service',
    Portfolio: 'Portefeuille',
    Pricing: 'Tarification',
    Customers: 'Clientes',
    Careers: 'Carrières',
    Resources: 'Ressources',
    Docs: 'Docs',
    Blog: 'Blog',
    eBooks: 'eBooks',
    Contact: 'Contacter',
    Help: 'Aider',
    Sales: 'Ventes',
    Advertise: 'Afficher',
    Webinars: 'Webinaires',
    Subscribe: `S'abonner`,
    'Stay Updated': 'Restez à jour',
    'Subscribe to our newsletter to get our latest news':
      'Abonnez-vous à notre newsletter pour recevoir nos dernières actualités',
    'Enter email address': `Entrer l'adresse e-mail`,
    'Terms & Conditions': 'termes et conditions',
    'Privacy Policy': 'Politique de confidentialité',
    Copyright: `droits d'auteur`,
  },
};
